import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// styles
import { css } from "@emotion/react"
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/core/Alert';
import AlertTitle from '@material-ui/core/AlertTitle';
// modules
import { closeBar } from '~/slices/commons/snackbar';


const SnackBar = () => {

  const dispatch = useDispatch();
  const snackbarState = useSelector(state => state.snackbar);

  const handleClose = () => {
    dispatch(closeBar());
  };

  useEffect(() => () => {
    const timer = setTimeout(() => handleClose(), 3000)
    // cleanup関数
    return () => {
      clearTimeout(timer);
      handleClose();
    }
  }, [])

  return (
    <div css={snackBar}>
      <Snackbar
        open={snackbarState.open}
        onClose={() => handleClose()}
        autoHideDuration={snackbarState.duration}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        ContentProps={{
          'aria-describedby': 'message-id',
        }}
        message={
          // severity: success, info, warning, error
          <Alert variant="outlined" severity={snackbarState.variant} onClose={() => handleClose()}>
            <AlertTitle className="message">
              <strong>{snackbarState.message}</strong>
             </AlertTitle>
          </Alert>
        }
      />
    </div>
  );
}

export default SnackBar;

const snackBar = css`
  .icon {
    margin-right: 0.5em;
    vertical-align: middle;
    align-items: center;
  }
  .MuiSnackbarContent-root {
    padding: 0;
    background-color: white;
  }
  .MuiSnackbarContent-message {
    padding: 0;
    width: 100%;
  }
  .MuiAlert-root {
    align-items: center;
    border-width: 2px;
  }
  .MuiAlert-message {
    width: 100%;
  }
  .message {
    margin: 0;
    text-align: left;
    strong {
      display: block;
      font-size: 1rem;
    }
    p {
      font-weight: bold;
      opacity: 0.7;
    }
    p:first-of-type {
      margin-top: 0.5rem;
    }
    p:last-of-type {
      margin-top: 1rem;
      text-align: right;
      font-size: 0.85rem;
      color: #da5c00;
      opacity: 1;
    }
  }
  .MuiLinearProgress-determinate,
  .MuiLinearProgress-bar1Determinate {
    border-radius: 3px;
  }
  .MuiLinearProgress-determinate {
    margin-top: 0.5rem;
  }
  .MuiLinearProgress-bar1Determinate {
    background-color: #da5c00;
  }
  .MuiLinearProgress-colorPrimary {
    background-color: #eacbb4;
  }
  .complete {
    .MuiLinearProgress-bar1Determinate {
      background-color: mediumseagreen;
    }
  }
  .MuiSnackbar-anchorOriginBottomCenter {
    bottom: 56px;
  }
`;
